import qs from 'query-string';

import { CATEGORY_LIST_FILTER_OPTION_MODEL, CATEGORY_LIST_PAGINATION_MODEL } from '../../store/modules/category/models';
import CategoryApi from '../../lib/api/category/CategoryApi';

/**
 * 카테고리 리스트 검색 시 사용되는 쿼리를 조작하는 custom hook
 * @return {{queryStringParser: (function(string, number): {filterOption: {sortType, exposureType, name, isExhibit, id, type, status}, pagination: {totalCnt: number, pageSize: number|number, pageNum: number|number}}), setQueryString: ((function(string, Object): (string|*))|*), queryFn: (function(string): {filterOption: {sortType: (Array<string|boolean|number|null>|string|boolean|number|null), exposureType: (Array<string|boolean|number|null>|string|boolean|number|null), name: (Array<string|boolean|number|null>|string|boolean|number|null), isExhibit: (Array<string|boolean|number|null>|string|boolean|number|null), pageSize: (Array<string|boolean|number|null>|string|boolean|number|null), id: (number|null), page: (Array<string|boolean|number|null>|string|boolean|number|null), type: (Array<string|boolean|number|null>|string|boolean|number|null), status: (Array<string|boolean|number|null>|string|boolean|number|null)}, pagination: {totalCnt, pageSize: number, pageNum: number}})}}
 */
const useCategoryListQueryOption = () => {
  /**
   * 쿼리스트링을 기존에 사용하던 filterOption, pagination 에 맞춰 파싱
   * @param queryString
   * @param totalCnt
   * @return {{filterOption: {sortType: (Array<string | boolean | number | null>|string|boolean|number|null), exposureType: (Array<string | boolean | number | null>|string|boolean|number|null), name: (Array<string | boolean | number | null>|string|boolean|number|null), degree: (Array<string | boolean | number | null>|string|boolean|number|number), isExhibit: (Array<string | boolean | number | null>|string|boolean|number|null), id: (Array<string | boolean | number | null>|string|boolean|number|null), type: (Array<string | boolean | number | null>|string|boolean|number|null), status: (Array<string | boolean | number | null>|string|boolean|number|null)}, pagination: {totalCnt, pageSize: (number|number), pageNum: (number|number)}}}
   */
  const queryStringParser = (queryString, totalCnt) => {
    const query = qs.parse(queryString);
    const pageSize = Number(query?.pageSize) || CATEGORY_LIST_PAGINATION_MODEL.pageSize;
    const pageNum = Number(query?.page) - 1 || CATEGORY_LIST_PAGINATION_MODEL.pageNum;

    return {
      filterOption: {
        id: query?.id || CATEGORY_LIST_FILTER_OPTION_MODEL.id,
        name: query?.name || CATEGORY_LIST_FILTER_OPTION_MODEL.name,
        type: query?.type || CATEGORY_LIST_FILTER_OPTION_MODEL.type,
        status: query?.status || CATEGORY_LIST_FILTER_OPTION_MODEL.status,
        isExhibit: query?.isExhibit || CATEGORY_LIST_FILTER_OPTION_MODEL.isExhibit,
        exposureType: query?.exposureType || CATEGORY_LIST_FILTER_OPTION_MODEL.exposureType,
        sortType: query?.sortType || CATEGORY_LIST_FILTER_OPTION_MODEL.sortType,
        degree: query?.degree || CATEGORY_LIST_FILTER_OPTION_MODEL.degree,
      },
      pagination: {
        pageSize,
        pageNum,
        totalCnt,
      },
    };
  };

  /**
   * queryStringParser를 통해 쿼리스트링을 기존에 사용하던 filterOption, pagination 에 맞춰 파싱한 다음 fetch Data와 함께 반환하는 함수
   * @param {string} queryString
   * @return {Promise<{filterOption: {sortType: (Array<string|boolean|number|null>|string|boolean|number|null), exposureType: (Array<string|boolean|number|null>|string|boolean|number|null), name: (Array<string|boolean|number|null>|string|boolean|number|null), isExhibit: (Array<string|boolean|number|null>|string|boolean|number|null), pageSize: (Array<string|boolean|number|null>|string|boolean|number|null), id: (number|null), page: (Array<string|boolean|number|null>|string|boolean|number|null), type: (Array<string|boolean|number|null>|string|boolean|number|null), status: (Array<string|boolean|number|null>|string|boolean|number|null)}, pagination: {totalCnt, pageSize: number, pageNum: number}}>}
   */
  const queryFn = async (queryString) => {
    const result = await CategoryApi.getCategoryList(queryString);

    const options = queryStringParser(queryString, result?.totalCount || 0);
    return {
      ...result,
      ...options,
    };
  };

  /**
   * queryString을 생성하여 반환하는 함수
   * queryString이 없을 경우 options의 initialData 에 맞춰 쿼리스트링을 생성하여 반환
   * @param {string} queryString
   * @param {object} options
   * @return {string|*}
   */
  const setQueryString = (queryString, options) => {
    if (queryString !== '') return queryString;

    if (options?.initialData) {
      const query = {
        pageSize: options.initialData.pagination.pageSize,
        page: options.initialData.pagination.pageNum + 1,
        degree: options.initialData.filterOption.degree,
      };
      return '?' + qs.stringify(query);
    }

    return '';
  };

  return { setQueryString, queryFn };
};

export default useCategoryListQueryOption;
